import React, { FC } from "react";
import { createPortal } from "react-dom";
import { Draggable } from "react-beautiful-dnd";
import { IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/CreateOutlined";
import DragIcon from "@mui/icons-material/DragIndicatorOutlined";
import { classNames } from "../../../../../utils/common/styling";
import { ISectionCTA } from "../ISectionCTA";
import { getThemedStyles, styles } from "../SectionCTA.styles";
import { useCreatorThemeContext } from "../../../../../features/Common/modules/Theme/CreatorThemeContext";

export const MovableSectionCTA: FC<ISectionCTA.IProps> = ({
  type,
  label,
  active,
  icon,
  onClick,
  id,
  index,
  className,
  labelClassName,
  labelStyle,
  showActions,
  onEdit,
}) => {
  const theme = useCreatorThemeContext();
  const themedStyles = getThemedStyles({ theme });
  const dragPortal = document.body;

  return (
    <Draggable
      draggableId={`draggable-${id}`}
      type={type ? `draggable-${type}-${id}` : `draggable-${id}`}
      index={index}
    >
      {(provided, snapshot) => {
        const ctaDragElement = (
          <span
            key={id}
            style={{ ...provided.draggableProps.style }}
            className="d-block"
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
          >
            <div
              className={classNames(
                styles.root,
                active && styles.active,
                active && themedStyles.active,
                snapshot.isDragging && styles.draggable,
                className,
              )}
              onClick={onClick}
            >
              <div className={styles.labelContainer}>
                {icon}
                <span
                  className={classNames(
                    styles.labelText,
                    active ? themedStyles.activeText : styles.notActiveText,
                    labelClassName,
                  )}
                  style={labelStyle}
                >
                  {label}
                </span>
              </div>
              {showActions && (
                <div className={styles.actions}>
                  <IconButton
                    onClick={(e) => {
                      // to not trigger `onClick` of cta itself on click of edit button
                      e.stopPropagation();

                      onEdit?.(e);
                    }}
                  >
                    <EditIcon />
                  </IconButton>
                  <div {...provided.dragHandleProps}>
                    <DragIcon className={styles.dragCta} />
                  </div>
                </div>
              )}
            </div>
          </span>
        );

        return snapshot.isDragging
          ? createPortal(ctaDragElement, dragPortal)
          : ctaDragElement;
      }}
    </Draggable>
  );
};
